import { Col, Row, Skeleton } from "antd";
import styles from "./PaymentTracking.module.css";
import {
  DatePickerInput,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { useEffect, useRef, useState } from "react";
import Modal from "../../../components/modal/Modal";
import Dropdown from "../../../components/dropdowns/Dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { CalendarIcon } from "../../../components/icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import moment from "moment";

const items = [
  { title: "Wedding Dress", category: "Clothes", spent: 100, status: "unpaid" },
  { title: "Flower Stage", category: "Caterer", spent: 300, status: "unpaid" },
  {
    title: "DJ Setup (Dave Smith)",
    category: "Musician",
    spent: 100,
    status: "unpaid",
  },
  {
    title: "Party Makeover (Mary Freund)",
    category: "Makeup Artists",
    spent: 300,
    status: "unpaid",
  },
];

const PaymentModal = ({ setModalOpen, setPaymentItems }) => {
  const currentItem = useRef();
  const [budgetList, setBudgetList] = useState(null);
  const [amount, setAmount] = useState("");
  const [ActualCost, setActualCost] = useState("");
  // const [status, setStatus] = useState("");
  const [date, setDate] = useState(null);

  const dispatch = useDispatch();

  const Budget = useSelector((state) => state.EventReducer.EventBudget);
  const addItem = () => {
    // setPaymentItems((prev) => [...prev, currentItem.current]);
    setModalOpen(false);
  };

  const handleChange = (name, value) => {
    currentItem.current = {
      ...currentItem.current,
      [name]: value,
    };
  };

  console.log(budgetList);

  const submit = () => {
    // console.log("adgggfdfggsdgsdgf", { budgetList, amount, date, status });
    if (!budgetList?.id?.id || !amount || !ActualCost) {
      dispatch(
        showAlert({
          title: "AddPayment",
          message: "Please add all payment details!",
          type: "Error",
        })
      );
    } else if (Math.sign(amount) != 1 || Math.sign(ActualCost) != 1) {
      dispatch(
        showAlert({
          title: "AddPayment",
          message: "Please enter amount greater than 0",
          type: "Error",
        })
      );
    } else {
      dispatch(
        EventMiddleware.addBudgetPayment({
          budget_id: budgetList?.id?.id,
          actual_cost: ActualCost,
          // status: status?.toLowerCase(),
          due_date: moment(date).format("YYYY-MM-DD"),
          amount,
        })
      )
        .then(() => setModalOpen(false))
        .catch();
    }
  };

  return (
    <Row className={styles.modalContentRow}>
      <Col xs={22} md={20}>
        <TextComponent textClass={styles.modalText}>Add Payment</TextComponent>
        <Row className={styles.modalInputs}>
          <Dropdown
            label="Budget List"
            placeholder="Party Makeover"
            name="title"
            object={Budget?.tracker?.map((data) => ({
              name: data?.category?.name,
              id: data,
            }))}
            onChange={(val) => {
              setBudgetList(val);
              setActualCost(val?.id?.actual_cost);
            }}
          />
          <InputField
            label="Notes"
            placeholder="Notes"
            type="text"
            value={budgetList?.id?.title}
            disabled
            // onChange={(e) => setAmount(e.target.value)}
          />
          <InputField
            label="Amount"
            placeholder="$340"
            type="number"
            name="spent"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />

          <InputField
            placeholder="$ 500"
            label="Actual Cost ($)"
            name="actual_cost"
            type="number"
            disabled={budgetList?.id?.actual_cost > 0 || !budgetList?.id}
            value={ActualCost}
            onChange={(e) => {
              setActualCost(e.target.value);
            }}
          />
          <DatePickerInput
            label="Payment Date"
            placeholder="March 04, 2023"
            icon={<CalendarIcon size={25} />}
            format={"MM-DD-YYYY"}
            onChange={(val, d) => {
              setDate(d);
            }}
          />
          {/*<Dropdown
            label="Status"
            placeholder="Unpaid"
            name="status"
            onChange={setStatus}
            options={[
              { value: "Paid", option: "Paid" },
              { value: "Unpaid", option: "Unpaid" },
            ]}
          /> */}
        </Row>
        <div className={styles.modalBtnContainer}>
          <SubmitButton
            title="Create"
            btnClass={styles.modalBtn}
            onClick={submit}
          />
        </div>
      </Col>
    </Row>
  );
};

const PaymentTracking = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentItems, setPaymentItems] = useState(items);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const Budget = useSelector((state) => state.EventReducer.EventBudget);

  const { state } = useLocation();

  // console.log("Budget", Budget);

  useEffect(() => {
    getBudgetData();
  }, []);

  const getBudgetData = () => {
    setLoading(true);
    dispatch(
      EventMiddleware.budget({ event_id: state?.eventData?.id, name: "" })
    )
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  const onDeletePayment = (id, index) => {
    dispatch(EventMiddleware.deleteBudgetPayment({ id })).then((data) => {
      setPaymentModal((prev) => {
        const cpy = { ...prev };
        cpy?.payments?.splice(index, 1);
        return cpy;
      });
    });
  };

  return (
    <Skeleton loading={loading}>
      <Row className={styles.upperRow}>
        {/* <Col xs={24} lg={12}>
          <Row className={styles.colorRow}>
            <Col md={8} lg={12}>
              <CircularProgressbar
                value={
                  Budget?.total_paid_count /
                  (Budget?.total_unpaid_count + Budget?.total_paid_count)
                }
                text={`${Budget?.total_paid_count} / ${Budget?.total_unpaid_count}`}
                maxValue={1}
                strokeWidth={6}
                styles={{
                  text: {
                    fill: "#000",
                    fontSize: "16px",
                  },
                  path: {
                    stroke: `var(--primary-color)`,
                  },
                  trail: {
                    stroke: "var(--primary-color)",
                    opacity: 0.4,
                  },
                }}
              />
            </Col>
            <Col md={6} lg={12}>
              <Row className={styles.colorLabel}>
                <div
                  className={`${styles.coloredCircle} ${styles.coloredCirclePaid}`}
                ></div>
                <TextComponent textClass={styles.labelText}>Paid</TextComponent>
              </Row>
              <Row className={styles.colorLabel}>
                <div
                  className={`${styles.coloredCircle} ${styles.coloredCircleUnpaid}`}
                ></div>
                <TextComponent textClass={styles.labelText}>
                  Unpaid
                </TextComponent>
              </Row>
            </Col>
          </Row>
        </Col> */}
        <Col xs={24} lg={12}>
          <Row className={styles.rightContainer}>
            <Col>
              <TextComponent textClass={styles.rightTitle}>
                Total Amount
              </TextComponent>
              <TextComponent textClass={styles.rightSubTitle}>
                Paid
              </TextComponent>
            </Col>
            <Col>
              <TextComponent textClass={styles.rightPrice}>
                ${Budget?.paid}
              </TextComponent>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className={styles.paymentsRow}>
        <Col>
          <TextComponent textClass={styles.heading}>Payments</TextComponent>
        </Col>
        {/* <Col>
          <TextComponent
            textClass={styles.link}
            onClick={() =>
              navigate("/events/budget/paymentTracking/payments", {
                state: {
                  headrTitle: "Payment Tracking",
                  eventData: state?.eventData,
                },
              })
            }
          >
            View All{" "}
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.89689 23.8528L11.9425 12.8944L1.98837 1.85295"
                stroke="var(--primary-color)"
                stroke-width="2.3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </TextComponent>
        </Col> */}
      </Row>
      <Row>
        <Col xs={24}>
          <Row className={styles.items} gutter={16}>
            {Budget?.tracker?.map((item) => (
              <Col xs={24} lg={12} key={item?.id}>
                <Row className={styles.itemRow}>
                  <Col xs={24} sm={16} md={16} lg={12}>
                    <TextComponent textClass={styles.itemTitle}>
                      {item?.category?.name}
                    </TextComponent>
                    <TextComponent textClass={styles.itemCategory}>
                      {item?.title}
                    </TextComponent>
                    <TextComponent textClass={styles.itemCategory}>
                      {moment(item?.date).format("MMM DD YYYY")}
                    </TextComponent>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={12}>
                    <TextComponent textClass={styles.amount}>
                      {`$${item?.total_budget}`}
                    </TextComponent>
                    {/* <TextComponent textClass={styles.status}>
                      {item?.status}
                    </TextComponent> */}
                    <TextComponent
                      textClass={styles.viewPayments}
                      onClick={() => setPaymentModal(item)}
                    >
                      Payments
                    </TextComponent>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
      <SubmitButton
        title="Add Payment"
        btnClass={styles.btn}
        onClick={() => setModalOpen(true)}
      />
      {modalOpen && (
        <Modal
          isModalOpen={modalOpen}
          setIsModalOpen={setModalOpen}
          closable={true}
          // pinkBg={true}
          className={styles.modal}
        >
          <PaymentModal
            setModalOpen={setModalOpen}
            setPaymentItems={setPaymentItems}
          />
        </Modal>
      )}

      {paymentModal && (
        <Modal
          isModalOpen={paymentModal}
          setIsModalOpen={setPaymentModal}
          closable={true}
          // pinkBg={true}
          className={styles.modal}
        >
          {/* <PaymentModal
            setModalOpen={setModalOpen}
            setPaymentItems={setPaymentItems}
          /> */}
          <TextComponent textClass={styles.itemTitle}>
            {paymentModal?.category?.name} Payments
          </TextComponent>
          <TextComponent textClass={styles.paymentModalCategory}>
            {paymentModal?.title}
          </TextComponent>
          {paymentModal?.payments?.map((item, i) => (
            <Col xs={24} lg={12} key={item?.id} style={{ maxWidth: "100%" }}>
              <Row className={styles.itemRow}>
                <Col xs={24} sm={16} md={16} lg={12}>
                  <TextComponent textClass={styles.itemTitle}>
                    Installment No {i + 1}
                  </TextComponent>
                  <TextComponent textClass={styles.paymentModalCategory}>
                    Payment Date:{" "}
                    {moment(item?.paid_date).format("MMM DD yyyy")}
                  </TextComponent>
                </Col>
                <Col xs={24} sm={8} md={8} lg={12}>
                  
                  <TextComponent textClass={styles.amount}>
                    {`$${item?.amount}`}
                  </TextComponent>
                  
                  <TextComponent textClass={styles.status}>
                    {paymentModal?.status}
                  </TextComponent>
                  <TextComponent
                    textClass={styles.viewPayments}
                    onClick={() => onDeletePayment(item.id, i)}
                  >
                    Delete
                  </TextComponent>
                </Col>
              </Row>
            </Col>
          ))}
        </Modal>
      )}
    </Skeleton>
  );
};

export default PaymentTracking;
